import $api from './Api';

export default {
    /*
     access: {
     requiresLogin: true,
     requiredPermissions: ['admin']
     },
     */
    authorize(requiresLogin, requiredPermissions) {
        let result = 'notAuthorized';
        let user = JSON.parse(window.localStorage.getItem('user')) || undefined;

        let token = window.localStorage.getItem('token') || undefined;

        $api.setHeader('Authorization', `Bearer ${token}`);

        if (requiresLogin === true && !token && !user) {
            return 'loginIsRequired';
        }

        if (!user) {
            if (token) window.localStorage.removeItem('token') || undefined;
            return 'notAuthorized';
        }

        if (
            requiresLogin === true &&
            !token &&
            (requiredPermissions || requiredPermissions.length === 0)
        ) {
            return 'authorized';
        }

        if (
            requiredPermissions &&
            requiredPermissions.length &&
            requiredPermissions.includes(user.role)
        ) {
            return 'authorized';
        }

        return result;
    }
};
